<template>
    <div>
        <p class="mb-3 has-text-weight-semibold has-text-secondary-black">
            Saldos en línea de tus cuentas bancarias
        </p>
        <ul
            data-testid="automaticAccountCards"
            style="display:grid; grid-template-columns: repeat(4,1fr); gap:16px"
        >
            <li
                class="listItem is-relative plainCard has-text-centered is-clipped"
                v-for="account in automaticAccounts"
                :key="account.id"
            >
                <p
                    class="has-text-primary-dark is-uppercase has-text-weight-semibold"
                    style="text-overflow:ellipsis; white-space: nowrap; overflow: hidden"
                    :title="account.financial_entity.name"
                >
                    {{ account.financial_entity.name }}
                </p>
                <p class="is-size-7 has-text-grey-dark">
                    {{ account.account_type }} Nº {{ account.number }}
                </p>
                <p class="has-text-weight-semibold">
                    {{ account.amount | toMoney }}
                </p>
            </li>
        </ul>
    </div>
</template>

<script>
import { parseToMoney } from "@/utils/currency";
export default {
    name: "AccountsCards",
    props: {
        accounts: {
            type: Array,
            default: function() {
                return [];
            },
        },
    },
    computed: {
        automaticAccounts: function() {
            return this.accounts.filter((item) => item.is_automatic);
        },
    },
    filters: {
        toMoney: (value) => {
            return parseToMoney(value);
        },
    },
};
</script>
